import { SelectListSingle } from '@/common'
import { useTranslation } from 'react-i18next'
import { DeclarantType } from '@/features/cbam-reporting/hooks/declarants'

type DeclarantTypeSelectorProps = {
  value: DeclarantType | '' | undefined
  onChange?: (value: DeclarantType) => void
  disabled?: boolean
  layout?: 'horizontal' | 'vertical'
}

export default function DeclarantTypeSelector({
  value,
  onChange,
  disabled = false,
  layout = 'horizontal'
}: DeclarantTypeSelectorProps) {
  const { t } = useTranslation()

  const className = layout === 'horizontal' ? 'flex gap-2' : 'grid grid-cols-2 gap-2'

  return (
    <SelectListSingle<DeclarantType>
      className={className}
      name="declarantType"
      onChange={onChange}
      disabled={disabled}
      items={[
        {
          id: 'importer',
          label: t('common:declarantType.IMPORTER.title'),
          value: DeclarantType.IMPORTER,
          children: (
            <span className="text-text-secondary text-sm">
              {t('common:declarantType.IMPORTER.description')}
            </span>
          ),
          isOpen: true,
          isChecked: value === DeclarantType.IMPORTER
        },
        {
          id: 'representative',
          label: t('common:declarantType.REPRESENTATIVE.title'),
          value: DeclarantType.REPRESENTATIVE,
          isChecked: value === DeclarantType.REPRESENTATIVE,
          isOpen: true,
          children: (
            <span className="text-text-secondary text-sm">
              {t('common:declarantType.REPRESENTATIVE.description')}
            </span>
          )
        }
      ]}
    />
  )
}
